import React, { FC, Fragment } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import Update from './Update';
import Create from './Create';
import { ClientDisclosure } from 'api';

interface Props {
  list: ClientDisclosure[];
}

const Disclosures: FC<Props> = ({ list }) => {
  return (
    <Fragment>
      <Create />

      <Grid container direction="column">
        {list.map(disclosure => (
          <Grid key={disclosure.id}>
            <Update disclosure={disclosure} />
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

export default Disclosures;
